<template>
  <NuxtLayout>
    <template v-if="!shouldWaitForAuth || isReady">
      <VitePwaManifest />
      <NuxtPage :key="$route.fullPath" />
      <CookieConsent />
    </template>

    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-KP9C2Z92"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
  </NuxtLayout>
</template>


<script setup>
import { useRoute } from "vue-router";
import { computed, ref, watchEffect , onMounted} from "vue";
import { useHead, useNuxtApp } from "#imports";
//import { useAuthStore } from "@/stores/authStore"; // Si vous utilisez @ comme alias
//import { useAuthStore } from "#imports";
import { useAuthStore } from "~/stores/authStore";
import { useCartStore } from "~/stores/cartStore";
import { useSeoDataStore } from "~/stores/seoDataStore";
import { useSeoKeywords } from '~/composables/useSeoKeywords'

//import { useI18n } from "#i18n";
import CookieConsent from "@/components/CookieConsent.vue";
//const { locale } = useI18n();


const cartStore = useCartStore ();
/*if (process.server) {
  const authStore = useAuthStore();
  await authStore.restoreAuth();
}*/

//const isReady = computed(() => authStore.isRestored);

// Appel de l’API qui centralise toutes les données user (depuis le cookie JWT)



/*if (data.value?.success) {
  const { profile, content } = data.value
  authStore.setProfile(profile, content)
} else {
  authStore.resetProfile?.() // si tu as une fonction pour réinitialiser
}*/
const cookiesAccepted = ref(false); // Forcer l'affichage
const seoDataStore = useSeoDataStore();
const { seoKeywords } = useSeoKeywords();

/*
if (import.meta.client && locale.value === "en-US") {
  locale.value = "en"; // 🔹 Corrige la langue pour éviter les erreurs
}*/

const route = useRoute();
const protectedRoutes = [
  "/student",
  "/user",
  "/admin",
  "/instructor",
  "/blogger",
  "/cart",
  "/checkout",
];

const shouldWaitForAuth = computed(() => {
  return protectedRoutes.some((path) => route.path.startsWith(path));
});

const { $translate } = useNuxtApp();
const copyrightYear = computed(() => `© ${new Date().getFullYear()} Longoka, Tous droits réservés`);
// ✅ Détection des pages dynamiques optimisée
const dynamicPages = [
  "course",
  "article",
  "craft",
  "book",
  "stationery",
  "clothing",
];
const isDynamicPage = computed(() => dynamicPages.includes(route.name));

// ✅ Stockage des traductions SEO avec cache sécurisé uniquement côté client
const translatedTitle = ref({});
const translatedDescription = ref({});
const cacheExpiration = 24 * 60 * 60 * 1000; // 1 jour

if (import.meta.client) {
  translatedTitle.value =
    JSON.parse(localStorage.getItem("translatedTitles")) || {};
  translatedDescription.value =
    JSON.parse(localStorage.getItem("translatedDescription")) || {};
}

async function translateAppSEO() {
  try {
    let targetLang = "fr"; // Valeur par défaut

    if (import.meta.client) {
      const userLang = navigator.language?.split("-")[0];
      targetLang = [
        "fr", "en", "es", "de", "it", "pt", "ru", "zh"
      ].includes(userLang) ? userLang : "fr";
    }

    translatedTitle.value = await $translate(
      "Espace culturel de partage de compétences",
      "fr",
      targetLang
    );

    translatedDescription.value = await $translate(
      "Longoka est une plateforme éducative interactive qui vous permet d'explorer des formations, lire des articles enrichissants et découvrir des livres inspirants et bien plus",
      "fr",
      targetLang
    );
  } catch (error) {
    console.error("❌ Erreur de traduction SEO :", error);
  }
}


  // Récupérer les titres des cours depuis l'API
const currentLang = computed(() => {
  if (!import.meta.client) return "fr"; // pour le SSR
  const navLang = navigator.language?.split("-")[0];
  return ["fr", "en", "es", "de", "it", "pt", "ru", "zh"].includes(navLang)
    ? navLang
    : "fr";
});

const resolvedTitle = computed(() =>
  isDynamicPage.value
    ? translatedTitle.value || "Espace culturel de partage de compétences"
    : "Espace culturel de partage de compétences | Longoka"
);

const resolvedDescription = computed(() =>
  isDynamicPage.value
    ? translatedDescription.value ||
      "Explorez Longoka, une plateforme de partage de compétences couvrant l'art, la culture, la technologie, et bien plus.Rejoignez notre communauté aujourd'hui !"
    : "Longoka est une plateforme éducative interactive qui vous permet d'explorer des formations, lire des articles enrichissants et découvrir des livres inspirants et bien plus."
);

const resolvedRobots = computed(() =>
  ["/login", "/checkout"].includes(route.path)
    ? "noindex, nofollow"
    : "index, follow"
);





watchEffect(() => {

// ✅ Exécuter la traduction au chargement


// ✅ Ajout des balises SEO
useHead({
  htmlAttrs: {
  lang: currentLang.value,
},

  title: computed(() => `${resolvedTitle.value} | Longoka`),
meta: [
  // Métadonnées de base
  { name: "description", content: resolvedDescription.value },
  { name: "keywords", content: seoKeywords.value },
  { name: "author", content: "Longoka Team" },
  { name: "robots", content: resolvedRobots.value },
  { name: "googlebot", content: "index, follow" },
  { name: "bingbot", content: "index, follow" },
  { name: "application-name", content: "Longoka" },
  { name: "theme-color", content: "#FF6600" },
  { name: "viewport", content: "width=device-width, initial-scale=1.0" },
  { name: "rating", content: "general" },
  { name: "viewport-fit", content: "cover" },
  { name: "referrer", content: "strict-origin-when-cross-origin" },
  { name: "color-scheme", content: "light dark" },
{ name: "yandex-verification", content: computed(() => process.env.YANDEX_SITE_VERIFICATION) }
,
  {
    name: "google-site-verification",
    content: computed(() => process.env.GOOGLE_SITE_VERIFICATION) ,
  },
  {
    name: "copyright",
    content: copyrightYear.value,
  },

  // Open Graph
 { property: "og:title", content: computed(() => `${resolvedTitle.value} | Longoka`) }

,
  { property: "og:description", content: computed(() => `${resolvedDescription.value}` ) },
  { property: "og:type", content: computed(() => "website") },

  { property: "og:url", content: computed(() => process.env.APP_DOMAIN || "https://longoka.com") },
  { property: "og:image", content: computed(() => `${process.env.APP_DOMAIN || "https://longoka.com"}/images/longoka_solo.png`) }
,
  { property: "og:site_name", content: computed(() => "Longoka") }
,
 { 
  property: "og:see_also", 
  content: computed(() => {
    const domain = (process.env.APP_DOMAIN || "https://longoka.com").replace(/\/$/, "");
    return `${domain}/categories`;
  })
}
,
  { property: "og:see_also", content: computed(() => `${process.env.APP_DOMAIN || "https://longoka.com"}/articles`) },
  { property: "og:see_also", content: computed(() => `${process.env.APP_DOMAIN || "https://longoka.com"}/courses`)},

  // Twitter
  { name: "twitter:card", content: "summary_large_image" },
  { name: "twitter:title", content: computed(() => `${resolvedTitle.value} | Longoka`) },
  { name: "twitter:description", content: computed(() => `${resolvedDescription.value}` ) },
  { name: "twitter:image", content: computed(() => `${process.env.APP_DOMAIN || "https://longoka.com"}/images/longoka_solo.png`) },
  { name: "twitter:site", content: "@Longoka" },
  { name: "twitter:creator", content: "@Longoka" }
],

  link: [
    { rel: "canonical", href: "https://longoka.com" },
    { rel: "alternate", hreflang: "fr", href: "https://longoka.com" },
    { rel: "alternate", hreflang: "en", href: "https://longoka.com/en" },
    { rel: "alternate", hreflang: "es", href: "https://longoka.com/es" },
    { rel: "alternate", hreflang: "de", href: "https://longoka.com/de" },
    { rel: "alternate", hreflang: "it", href: "https://longoka.com/it" },
    { rel: "alternate", hreflang: "pt", href: "https://longoka.com/pt" },
    { rel: "alternate", hreflang: "ru", href: "https://longoka.com/ru" },
    { rel: "alternate", hreflang: "zh", href: "https://longoka.com/zh" },
    { rel: "alternate", hreflang: "x-default", href: "https://longoka.com" },
    { rel: "preconnect", href: "https://fonts.googleapis.com" },
    { rel: "preconnect", href: "https://www.googletagmanager.com" },
    { rel: "dns-prefetch", href: "https://cdn.jsdelivr.net" },
    { rel: "manifest", href: "/manifest.json" },
    { rel: "apple-touch-icon", href: "/apple-touch-icon.png" },
    { rel: "mask-icon", href: "/safari-pinned-tab.svg", color: "#ff4500" },
  {
  rel: "sitemap",
  href: computed(() => {
    const domain = (process.env.APP_DOMAIN || "https://longoka.com").replace(/\/$/, "");
    return `${domain}/sitemap.xml`;
  }),
  type: "application/xml"
}
,
  ],
  script: [
    {
      type: "application/ld+json",
      /*children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Longoka",
        url: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}`),
       description: computed(() => translatedDescription.value)
 ||
          "Longoka est une plateforme de formation et de commerce en ligne offrant des cours, livres, artisanat et mode.",
        logo: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/images/longoka_logo.png`),
        sameAs: [
          "https://www.facebook.com/Longoka",
          "https://www.twitter.com/Longoka",
          "https://www.instagram.com/Longoka",
        ],
        breadcrumb: {
          "@type": "BreadcrumbList",
          itemListElement: [
                {
              "@type": "ListItem",
              position: 1,
              name: "Accueil",
              item: "https://longoka.fr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Cours",
              item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/courses`),
            },
            
          
              {
              "@type": "ListItem",
              position: 3,
              name: "Articles",
                            item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/articles`),

            },
              {
              "@type": "ListItem",
              position: 4,
              name: "Shop",
              item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/shop`),
              
            },
            {
              "@type": "ListItem",
              position: 5,
              name: "Books",
                            item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/books`),

            },
                {
              "@type": "ListItem",
              position: 6,
              name: "Crafts",
                           item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/crafts`),

            },
                  {
              "@type": "ListItem",
              position: 7,
              name: "Stationeries",
                            item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/stationeries`),

            },
                  {
              "@type": "ListItem",
              position: 8,
              name: "Clothes",
                            item: computed(() => `${process.env.APP_DOMAIN || "https://longoka.fr"}/clothes`),

            },
          ],
        },
      }),*/
      children: JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Longoka",
  url: process.env.APP_DOMAIN || "https://longoka.fr",
  description:
    translatedDescription.value ||
    "Longoka est une plateforme de formation et de commerce en ligne offrant des cours, livres, artisanat et mode.",
  logo: `${process.env.APP_DOMAIN || "https://longoka.fr"}/images/longoka_logo.png`,
  sameAs: [
    "https://www.facebook.com/Longoka",
    "https://www.twitter.com/Longoka",
    "https://www.instagram.com/Longoka",
  ],
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: "https://longoka.fr",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Cours",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/courses`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Articles",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/articles`,
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Shop",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/shop`,
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "Books",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/books`,
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "Crafts",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/crafts`,
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "Stationeries",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/stationeries`,
      },
      {
        "@type": "ListItem",
        position: 8,
        name: "Clothes",
        item: `${process.env.APP_DOMAIN || "https://longoka.fr"}/clothes`,
      },
    ],
  },
}),

    },
    {
      type: "text/javascript",
      innerHTML: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${process.env.GTM_ID}');
      `,
    },
  ],
});

})


onMounted(async () => {
  await translateAppSEO();

  
    
    await cartStore.setCart();
   
  

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("cookies")) {
    localStorage.removeItem("cookiesAccepted");
  }

  const consent = localStorage.getItem("cookiesAccepted");
  cookiesAccepted.value = consent === "true";
});



// ✅ Vérification et mise à jour des traductions avec watchEffect()
if (import.meta.client) {
  watchEffect(async () => {
    if (isDynamicPage.value) {
      const title = document.title;
      const description = document.querySelector('meta[name="description"]')?.content;
      if (title && description) {
        await fetchTranslations(title, description);
        document.title = translatedTitle.value || title;
      }
    }
  });
}

</script>


<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>